import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const selectAdfoxOffer = rootStateBranchSelector('adfoxOffer');
